import React from 'react'

export default class IconsAlignStretch extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color

        return (
            <svg
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                style={this.props.style}
            >
                <path
                    d='M5.33268 1.33337H3.99935C3.26297 1.33337 2.66602 1.93033 2.66602 2.66671V13.3334C2.66602 14.0698 3.26297 14.6667 3.99935 14.6667H5.33268C6.06906 14.6667 6.66602 14.0698 6.66602 13.3334V2.66671C6.66602 1.93033 6.06906 1.33337 5.33268 1.33337Z'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M12.0007 1.33337H10.6673C9.93094 1.33337 9.33398 1.93033 9.33398 2.66671V13.3334C9.33398 14.0698 9.93094 14.6667 10.6673 14.6667H12.0007C12.737 14.6667 13.334 14.0698 13.334 13.3334V2.66671C13.334 1.93033 12.737 1.33337 12.0007 1.33337Z'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
